import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGrid, faList } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Form, Link, SidebarNoticeBox,
} from '@domain-group/suit-theme'

import { pascalToSnakeCase, snakeToTitleCase } from '@domain-group/javascript-utils'

import { useSetState } from '@domain-group/react-hooks'

import useImages from '@hooks/useImages'

import GridView from '../Views/Grid'
import ListView from '../Views/List'

interface ImageListProps {
  imageOptions:{
    imageable_id: number,
    imageable_type: string,
  },
}

type DefaultState = {
  gridView: boolean,
}

const defaultState: DefaultState = {
  gridView: false,
}

const ImageList = (props: ImageListProps) => {
  const { imageOptions } = props
  const { imageable_type } = imageOptions

  const [state, setState] = useSetState(defaultState)
  const { gridView } = state

  const imagesPayload = useImages({
    filters: {
      ...imageOptions,
    },
    performHttpRequests: true,
  })

  const {
    filteredImages,
    hasFilteredImages,
    loading,
  } = imagesPayload

  const Component = gridView ? GridView : ListView

  return (
    <Box flexDirection="column" marginTop="large">
      {/*
       // @ts-expect-error TS2741 */}
      <Form.Field
        label={`${snakeToTitleCase(pascalToSnakeCase(imageable_type))} Images`}
        labelRight={(
          <Link
            onClick={() => setState({ gridView: !gridView })}
            style={{ textDecoration: 'none' }}
            textProps={{ fontSize: 'xsmall' }}
          >
            {gridView ? 'List View ' : 'Grid View ' }
            <FontAwesomeIcon icon={gridView ? faList : faGrid} />
          </Link>
        )}
      />

      <Box>
        {!loading && !hasFilteredImages && (
          <SidebarNoticeBox boxProps={{ marginBottom: 'none' }}>
            <SidebarNoticeBox.Title>No Images Present</SidebarNoticeBox.Title>
          </SidebarNoticeBox>
        )}

        {!loading && hasFilteredImages && (
          <Component images={filteredImages} />
        )}
      </Box>
    </Box>
  )
}

export default ImageList
